const VersionType = Object.freeze({
  RUST: "rust",
  NODE: "nodojs",
});

const buttons = Object.freeze({
  [VersionType.RUST]: document.getElementById("rust_version_btn"),
  [VersionType.NODE]: document.getElementById("nodejs_version_btn"),
});

const projects = Object.freeze({
  [VersionType.RUST]: document.querySelectorAll(".rust.project"),
  [VersionType.NODE]: document.querySelectorAll(".nodejs.project"),
});

let versionType = VersionType.NODE;

// set up event listeners
Object.entries(buttons).forEach(([type, element]) => {
  element.addEventListener("click", () => {
    versionType = type;
    updateStatus();
  });
});

updateStatus();

function updateStatus() {
  Object.entries(buttons).forEach(([type, element]) => {
    if (type === versionType) element.classList.add("active");
    else element.classList.remove("active");
  });

  Object.entries(projects).forEach(([type, elements]) => {
    elements.forEach((element) => {
      element.style.display = type === versionType ? "" : "none";
    });
  });
}
